import type { LocaleMessageBundle } from '../../types'

export const deliveryPartnerMessages: LocaleMessageBundle = {
  vi: {
    'deliveryPartner.model': 'đối tác vận chuyển',
    'deliveryPartner.fields.code': 'Mã',
    'deliveryPartner.fields.name': 'Tên',
    'deliveryPartner.fields.phone': 'Số điện thoại',
    'deliveryPartner.fields.email': 'Email',
    'deliveryPartner.fields.address': 'Địa chỉ',
    'deliveryPartner.fields.note': 'Ghi chú',
    'deliveryPartner.fields.status': 'Trạng thái',
    'deliveryPartner.placeholders.code': 'Tự sinh nếu để trống',
    'deliveryPartner.placeholders.name': 'Nhập tên đối tác',
    'deliveryPartner.placeholders.phone': 'Số điện thoại',
    'deliveryPartner.placeholders.email': 'Email',
    'deliveryPartner.placeholders.address': 'Địa chỉ',
    'deliveryPartner.placeholders.note': 'Ghi chú',
    'deliveryPartner.actions.create': 'Thêm đối tác vận chuyển',
    'deliveryPartner.actions.quickCreate': 'Thêm nhanh đơn vị vận chuyển',
    'deliveryPartner.actions.update': 'Cập nhật đối tác vận chuyển',
    'deliveryPartner.actions.cancel': 'Đóng',
    'deliveryPartner.dialog.createSubtitle': 'Quản lý đối tác giao hàng / vận chuyển',
    'deliveryPartner.dialog.updateSubtitle': 'Chỉnh sửa thông tin đối tác',
    'deliveryPartner.deleteConfirm': 'Xóa đối tác "{name}"?',
    'deliveryPartner.errors.saveFailed': 'Không thể lưu đối tác vận chuyển',
    'deliveryPartner.notifications.createFailed': 'Thêm đối tác vận chuyển không thành công.',
    'deliveryPartner.notifications.updateFailed': 'Cập nhật đối tác vận chuyển không thành công.',
    'deliveryPartner.notifications.deleteFailed': 'Xóa đối tác vận chuyển không thành công.',
  },
  en: {
    'deliveryPartner.model': 'delivery partner',
    'deliveryPartner.fields.code': 'Code',
    'deliveryPartner.fields.name': 'Name',
    'deliveryPartner.fields.phone': 'Phone',
    'deliveryPartner.fields.email': 'Email',
    'deliveryPartner.fields.address': 'Address',
    'deliveryPartner.fields.note': 'Note',
    'deliveryPartner.fields.status': 'Status',
    'deliveryPartner.placeholders.code': 'Auto-generated if empty',
    'deliveryPartner.placeholders.name': 'Enter partner name',
    'deliveryPartner.placeholders.phone': 'Phone',
    'deliveryPartner.placeholders.email': 'Email',
    'deliveryPartner.placeholders.address': 'Address',
    'deliveryPartner.placeholders.note': 'Note',
    'deliveryPartner.actions.create': 'Add delivery partner',
    'deliveryPartner.actions.quickCreate': 'Quick add delivery partner',
    'deliveryPartner.actions.update': 'Update delivery partner',
    'deliveryPartner.actions.cancel': 'Cancel',
    'deliveryPartner.dialog.createSubtitle': 'Manage shipping / delivery partners',
    'deliveryPartner.dialog.updateSubtitle': 'Edit partner details',
    'deliveryPartner.deleteConfirm': 'Delete partner "{name}"?',
    'deliveryPartner.errors.saveFailed': 'Failed to save delivery partner',
    'deliveryPartner.notifications.createFailed': 'Adding delivery partner was unsuccessful.',
    'deliveryPartner.notifications.updateFailed': 'Updating delivery partner was unsuccessful.',
    'deliveryPartner.notifications.deleteFailed': 'Deleting delivery partner was unsuccessful.',
  },
}
